var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
import { ChipSelectionMode } from '../../shared/chip/chip.interface';
/**
 * Represents the sparkline chart
 */
let DinapsisCollectionChips = class DinapsisCollectionChips extends LitElement {
    constructor() {
        super();
        /**
         * A property that is used to generate unique idChip
         */
        this.idCollectionChip = `collectionChip-${uuidv4()}`;
        this.mode = ChipSelectionMode.Multiple;
    }
    createRenderRoot() {
        return this;
    }
    /**
     * This method remove a chip.
     */
    removeChip(event) {
        this.model.chips = this.model.chips.filter((chip) => chip.id !== event.detail);
        event.currentTarget.remove();
        this.dispatchEvent(new CustomEvent('remove-chip', { detail: event.detail }));
    }
    /**
     * This method changes the selected button in the user interface and calls tableModeActive().
     * @param {any} evt - The event that triggered the method.
     * @returns {void}
     */
    clickChip(evt) {
        const selectedChips = [];
        const compCollectionChip = document.querySelector(`#${this.idCollectionChip}`);
        if (compCollectionChip) {
            const nodes = compCollectionChip.querySelectorAll('dinapsis-chip');
            if (nodes) {
                const childNodes = [...nodes];
                childNodes.forEach((child) => {
                    var _a, _b, _c;
                    if ((_a = child.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList.contains('activated')) {
                        if (((_b = child.firstElementChild) === null || _b === void 0 ? void 0 : _b.id) !== evt.detail.divId) {
                            if (this.mode === ChipSelectionMode.Single) {
                                child.firstElementChild.classList.remove('activated');
                            }
                            else {
                                const id = (_c = child.firstElementChild) === null || _c === void 0 ? void 0 : _c.id.split('-')[1];
                                const selectChip = this.model.chips.find((chip) => chip.id === id);
                                if (selectChip) {
                                    selectedChips.push(selectChip);
                                }
                            }
                        }
                        else {
                            selectedChips.push(evt.detail.model);
                        }
                    }
                });
            }
        }
        // Lanza el cambio
        this.dispatchEvent(new CustomEvent('click-chip', { detail: evt.detail.model }));
        this.dispatchEvent(new CustomEvent('change-chip', { detail: selectedChips }));
    }
    /**
     * This method create a HTML chip.
     *
     * @returns {string} - The HTML string for the icon, or an empty string if not set
     */
    chip(chip) {
        if (chip) {
            return html `<dinapsis-chip .model=${chip} @remove-chip=${this.removeChip} @click-chip=${this.clickChip}></dinapsis-chip>`;
        }
        return '';
    }
    /**
     * This method creates a chips for the user interface.
     *
     * @returns {string} - The HTML string for the icon, or an empty string if not set
     */
    createChips() {
        if (this.model && this.model.chips && this.model.chips.length > 0) {
            const result = this.model.chips
                .map((chip) => this.chip(chip));
            return result;
        }
        return '';
    }
    render() {
        return html `
      <div class="collection-chip" id="${this.idCollectionChip}">
        ${this.createChips()}
      </div>
    `;
    }
};
__decorate([
    property()
], DinapsisCollectionChips.prototype, "model", void 0);
__decorate([
    property()
], DinapsisCollectionChips.prototype, "mode", void 0);
DinapsisCollectionChips = __decorate([
    customElement('dinapsis-collection-chips')
], DinapsisCollectionChips);
export { DinapsisCollectionChips };
//# sourceMappingURL=dinapsis-collection-chips.js.map